import React, { useState } from 'react';
import { useServerNotifications } from '../../../contexts/ServerNotificationsContext';
import { useProcesses } from '../../../contexts/ProcessesContext';
import ActivityButton from './ActivityButton';
import ActivityPopover from './ActivityPopover';
import '../../../stylesheets/server-notifications.scss';
import '../../../stylesheets/activity.scss';

/**
 * Coordinates the activity button and the notifications and processes popover.
 * @returns The activity control and its popover.
 */
const Activity = () => {
    const { unresolvedCount, notifications } = useServerNotifications();
    const { hasActiveProcesses, isWaitingForProcess, loadProcesses } =
        useProcesses();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        if (!anchorEl) {
            void loadProcesses();
        }
    };

    return (
        <>
            <ActivityButton
                unresolvedCount={unresolvedCount}
                hasActiveProcesses={hasActiveProcesses || isWaitingForProcess}
                open={Boolean(anchorEl)}
                onClick={handleOpen}
            />
            <ActivityPopover
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                notifications={notifications}
            />
        </>
    );
};

export default Activity;
